import { Button, FormControl, FormLabel, Input, SimpleGrid } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { fetchCompany, updateSocialMedia } from '../../../../../store/actions';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';

import { AppDispatch } from '../../../../../store';
import { socialAccountType } from '../../../../../types';
import { useFormik } from 'formik';

export const SocialMediaSection = () => {

    const [isUpdatingSocialMedia, setIsUpdatingSocialMedia] = useState<boolean>(false);

    const { company } = useAppSelector(state => state.companyReducer);

    const { company_id, website } = company;

    const dispatch: AppDispatch = useAppDispatch();

    const socialMediaForm = useFormik({
        initialValues: {
            whatsapp: {
                name: 'whatsapp',
                url: ''
            },
            facebook: {
                name: 'facebook',
                url: ''
            },
            instagram: {
                name: 'instagram',
                url: ''
            },
            twitter: {
                name: 'twitter',
                url: ''
            },
            linkedin: {
                name: 'linkedin',
                url: ''
            },
        },
        onSubmit: (values: any) => {
            setIsUpdatingSocialMedia(true);
            const newValues = { company_id, social_media: Object.values(values) };
            dispatch(updateSocialMedia(newValues))
                .then(() => { setIsUpdatingSocialMedia(false); dispatch(fetchCompany()); })
                .catch(() => setIsUpdatingSocialMedia(false));
        }
    });

    const getSocialMediaUrl = (media: string) => {
        const [socialMedia] = website?.social_media?.filter((item: socialAccountType) => item?.name === media);
        return socialMedia?.url;
    };

    const setSocialMediaValues = () => {
        if (getSocialMediaUrl('whatsapp')) socialMediaForm.setFieldValue('whatsapp.url', getSocialMediaUrl('whatsapp'));
        if (getSocialMediaUrl('facebook')) socialMediaForm.setFieldValue('facebook.url', getSocialMediaUrl('facebook'));
        if (getSocialMediaUrl('instagram')) socialMediaForm.setFieldValue('instagram.url', getSocialMediaUrl('instagram'));
        if (getSocialMediaUrl('twitter')) socialMediaForm.setFieldValue('twitter.url', getSocialMediaUrl('twitter'));
        if (getSocialMediaUrl('linkedin')) socialMediaForm.setFieldValue('linkedin.url', getSocialMediaUrl('linkedin'));
    };

    useEffect(() => {
        setSocialMediaValues();
    }, []);

    return (
        <>
            <form onSubmit={socialMediaForm.handleSubmit}>
                <SimpleGrid columns={[1, 1, 2, 2]} spacing={3}>
                    <FormControl>
                        <FormLabel>WhatsApp number</FormLabel>
                        <Input name='whatsapp'
                            value={socialMediaForm.values.whatsapp.url}
                            onChange={(event => {
                                socialMediaForm.setFieldValue('whatsapp', {
                                    name: 'whatsapp',
                                    url: event.currentTarget.value
                                });
                            })}
                            placeholder='0123456789'
                            _focusVisible={{
                                boxShadow: '0 0 0 1px #ffc107'
                            }}
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Facebook URL</FormLabel>
                        <Input name='facebook'
                            value={socialMediaForm.values.facebook.url}
                            onChange={(event => {
                                socialMediaForm.setFieldValue('facebook', {
                                    name: 'facebook',
                                    url: event.currentTarget.value
                                });
                            })}
                            placeholder='https://facebook.com'
                            _focusVisible={{
                                boxShadow: '0 0 0 1px #ffc107'
                            }}
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Instagram URL</FormLabel>
                        <Input name='instagram'
                            value={socialMediaForm.values.instagram.url}
                            onChange={(event => {
                                socialMediaForm.setFieldValue('instagram', {
                                    name: 'instagram',
                                    url: event.currentTarget.value
                                });
                            })}
                            placeholder='https://instagram.com'
                            _focusVisible={{
                                boxShadow: '0 0 0 1px #ffc107'
                            }}
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Twitter URL</FormLabel>
                        <Input name='twitter'
                            value={socialMediaForm.values.twitter.url}
                            onChange={(event => {
                                socialMediaForm.setFieldValue('twitter', {
                                    name: 'twitter',
                                    url: event.currentTarget.value
                                });
                            })}
                            placeholder='https://twitter.com'
                            _focusVisible={{
                                boxShadow: '0 0 0 1px #ffc107'
                            }}
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>LinkedIn URL</FormLabel>
                        <Input name='linkedin'
                            value={socialMediaForm.values.linkedin.url}
                            onChange={(event => {
                                socialMediaForm.setFieldValue('linkedin', {
                                    name: 'linkedin',
                                    url: event.currentTarget.value
                                });
                            })}
                            placeholder='https://linkedin.com'
                            _focusVisible={{
                                boxShadow: '0 0 0 1px #ffc107'
                            }}
                        />
                    </FormControl>
                </SimpleGrid>
                <Button
                    my={3}
                    float={'right'}
                    colorScheme={'yellow'}
                    type='submit'
                    disabled={isUpdatingSocialMedia || !socialMediaForm.isValid}
                    isLoading={isUpdatingSocialMedia}
                    loadingText={'Updating...'}
                >Update</Button>
            </form>
        </>
    );
};